import React from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import styles from '../../../src/assets/styles/HomePage.module.scss';

import Header from '../Header';
import Footer from '../Footer';

const Cenik = () => {
    return (
        <div>
            <Container fluid className={`g-0`}>
                <Header headerAbsolute={true} />
                <div className={`${styles.heroImage} ${styles.heroImageCenik}`}>
                    <div className={styles.heroText}>
                        <h1>Ceník</h1>
                    </div>
                </div>
            </Container>
            <Container className="py-5">
                <Row className="justify-content-center">
                    <Col md={9}>
                        <Card>
                            <Card.Header as="h2" className="text-center">Vstupné</Card.Header>
                            <Card.Body>
                                <Card.Text className='lead'>
                                    V herně Mauglí platíte vstupné za hrající si děti bez ohledu na věk.
                                </Card.Text>
                                <ListGroup variant="flush">
                                    <ListGroup.Item>
                                        <strong>100 Kč</strong> za pobyt do jedné hodiny
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <strong>150 Kč</strong> za pobyt delší než jedna hodina
                                    </ListGroup.Item>
                                </ListGroup>
                                <Card.Text>
                                    Vstupné je jednorázové a platí pro celý den. Není možné hernu Mauglí během dne opakovaně navštěvovat na jednu vstupenku.
                                </Card.Text>
                                <Card.Text className='mt-3'>
                                    Dospělí a doprovod starší 18 let mají vstup zdarma.
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Footer/>
        </div>
    );
};

export default Cenik;
